import { Component, Input, OnInit } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { SmallTitleComponent } from '@atoms/small-title/small-title.component';

type Tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

@Component({
  selector: 'app-title',
  imports: [NgTemplateOutlet, SmallTitleComponent],
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent implements OnInit {
  @Input() tag: string | Tag = 'h1';
  @Input('tag-class') tagClass?: string | Tag;
  @Input('sup-title') supTitle?: string | null;
  @Input() type: 'default' | 'light' = 'default';
  public classes: string = '';

  ngOnInit(): void {
    const classes: string[] = ['title__main'];
    classes.push(this.tagClass ? 'title__main--' + this.tagClass : 'title__main--' + this.tag);
    classes.push('title__main--type-' + this.type);
    this.classes = classes.join(' ');
  }
}
